module.exports = __webpack_public_path__ + "static/media/total_logo_text.642c425e.png";